import React from 'react';
import { ROUTE_NAMES } from '../../Routes';
import { Helmet } from 'react-helmet-async';
import { Link, useLocation } from 'react-router-dom';

import P_1 from '../../assets/press/Press-1-1.png';
import P_2 from '../../assets/press/Press-2-1.webp';
import P_3 from '../../assets/press/Press-3-1.jpg';
import P_10_1 from '../../assets/press/Press-10-1.jpg';
import P_10_2 from '../../assets/press/Press-10-2.jpg';
import P_10_3 from '../../assets/press/Press-10-3.jpg';
import P_10_4 from '../../assets/press/Press-10-4.jpg';
import P_10_5 from '../../assets/press/Press-10-5.jpg';
import P_10_6 from '../../assets/press/Press-10-6.jpg';
import P_10_7 from '../../assets/press/Press-10-7.jpg';
import P_10_8 from '../../assets/press/Press-10-8.jpg';
import P_10_9 from '../../assets/press/Press-10-9.jpg';
import P_10_10 from '../../assets/press/Press-10-10.jpg';
import P_10_11 from '../../assets/press/Press-10-11.jpg';
import P_10_12 from '../../assets/press/Press-10-12.jpg';

const pressList = [
	{
		image: P_1,
		title:
			'Starlife: Construction Starts on ’21 Hollywood’ at 2100 N. Federal Highway, Hollywood, FL, 33020',
		link: ROUTE_NAMES.PRESS1,
	},
	{
		image: P_2,
		title:
			'21 Hollywood, a new 13-story mixed-use apartment development is coming to the heart of Hollywood',
		link: ROUTE_NAMES.PRESS2,
	},
	{
		image: P_3,
		title:
			'Exclusive & Iconic: Starlife Group’s 21 Hollywood Recognized as the Best in Luxury Real Estate',
		link: ROUTE_NAMES.PRESS3,
	},
];

export default function PressPage10() {
	const location = useLocation();
	const canonicalUrl = `https://www.thestarlifegroup.com${location.pathname}`;

	return (
		<div className='press-single-page'>
			<Helmet>
				<title>
					Foundation Work Progresses on 21 Hollywood at 2100 N. Federal Highway
					in Hollywood, Florida.
				</title>
				<meta
					name='description'
					content='Construction is advancing at 21 Hollywood, a 14-story mixed-use development currently underway at 2100 N. Federal Highway in Hollywood, Florida.'
				/>
				<meta
					name='keywords'
					content='Starlife press, Real estate news, Luxury property updates, Real estate investment insights, Starlife Group announcements, Property market trends'
				/>
				<link rel='canonical' href={canonicalUrl} />
			</Helmet>
			<div className='col-1'>
				<img src={P_10_1} alt='press-image' />
				<h2 className='press-page-title'>
					Foundation Work Progresses on 21 Hollywood at 2100 N. Federal Highway
					in Hollywood, Florida.
				</h2>
				<span className='author-name'>By Oscar Nunez</span>
				<span className='author-name'>May 1, 2025</span>
				<Link
					to={
						'https://whatnow.com/miami/real-estate/first-concrete-poured-as-construction-progresses-on-21-hollywood/'
					}
				>
					<span className='author-name'>Source</span>
				</Link>

				<div className='press-page-content'>
					<p>
						Construction is advancing at 21 Hollywood, a 14-story mixed-use
						development currently underway at 2100 N. Federal Highway in
						Hollywood, Florida. Designed by Miami-based architect Kobi Karp and
						developed by Starlife Group, the project recently reached a key
						construction milestone with the completion of the initial series of
						concrete slab pours for the foundation. The project broke ground in
						December 2024 and is targeting structural topping out by October
						2025, with full completion anticipated between late 2026 and early
						2027. Starlife Builders, the construction subsidiary of Starlife
						Group, is serving as the general contractor.
					</p>
					<img src={P_10_2} alt='press-image_2' />
					<p>Credit: 21 Hollywood.</p>
					<img src={P_10_3} alt='press-image_3' />
					<p>Credit: 21 Hollywood.</p>
					<p>
						Located on a 1.48-acre parcel near the Atlantic Ocean and the city’s
						revitalized downtown corridor, the development is set to deliver 200
						luxury rental residences and 10,000 square feet of ground-floor
						retail space.
					</p>
					<img src={P_10_4} alt='press-image_4' />
					<p>Credit: 21 Hollywood.</p>
					<img src={P_10_5} alt='press-image_5' />
					<p>Credit: 21 Hollywood.</p>
					<img src={P_10_6} alt='press-image_6' />
					<p>Credit: 21 Hollywood.</p>
					<p>
						“21 Hollywood embodies our commitment to building thoughtfully
						designed spaces that bring lasting value to residents, investors,
						and the South Florida community,” said Gevorg Shahbazyan, CEO and
						Founder of Starlife Group. “The project is destined to become a
						South Florida landmark that will leave a legacy on the City of
						Hollywood.”
					</p>
					<img src={P_10_7} alt='press-image_7' />
					<p>Credit: 21 Hollywood.</p>
					<img src={P_10_8} alt='press-image_8' />
					<p>Credit: 21 Hollywood.</p>
					<p>
						Vertical construction will deliver a comprehensive amenity package.
						Plans call for a business center with 16-foot ceilings, co-working
						areas, and a private conference room. Wellness-oriented amenities
						will include a fitness center with 14-foot ceilings, a yoga and
						Pilates studio, a children’s playroom, a pet park with washing
						stations, dual screening rooms, and an 85-foot infinity-edge
						swimming pool.
					</p>
					<img src={P_10_9} alt='press-image_9' />
					<p>Credit: 21 Hollywood.</p>
					<img src={P_10_10} alt='press-image_10' />
					<p>Credit: 21 Hollywood.</p>
					<p>
						“Pouring the first slab of 21 Hollywood is a significant milestone
						for the entire team, marking the transition from vision to reality,”
						said Arman Shahbazyan, Co-Founder and President of Starlife Group,
						and head of Starlife Builders. “As vertical construction progresses,
						each phase will bring us closer to delivering a transformative
						residential experience in the heart of Hollywood.”
					</p>
					<img src={P_10_11} alt='press-image_11' />
					<p>Credit: 21 Hollywood.</p>
					<img src={P_10_12} alt='press-image_12' />
					<p>Credit: 21 Hollywood.</p>
					<iframe
						title='Google Map Location'
						src='https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d380.45000311221446!2d-80.14369!3d26.030303000000004!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88d9abaa6d3f33b9%3A0xc2c60b28d83d4594!2s2100%20N%20Federal%20Hwy%2C%20Hollywood%2C%20FL%2033020!5e1!3m2!1sen!2sus!4v1754314360628!5m2!1sen!2sus'
						width='100%'
						height='400'
						style={{ border: 0 }}
						allowFullScreen=''
						loading='lazy'
						referrerPolicy='no-referrer-when-downgrade'
					></iframe>
				</div>
			</div>
			<div className='col-2'>
				<div className='sticky-press-list'>
					<h3>Press Articles</h3>
					{pressList.map((item, idx) => (
						<Link to={item.link} key={idx}>
							<div className='other-press-card'>
								<img src={item.image} alt={`press-${idx}`} />
								<p>{item.title}</p>
							</div>
						</Link>
					))}
					<Link to={ROUTE_NAMES.PRESS}>
						<button className='view-all-press-btn'>View All</button>
					</Link>
				</div>
			</div>
		</div>
	);
}
